import validationMessages from 'vee-validate/dist/locale/pt_BR';
//citrix.com.br

const yesNoOptions = [
    {value: "Yes", text: "Sim"},
    {value: "No", text: "Não"}
]

export default {
    privacyLinkLabel: "política de privacidade.",
    privacyLink: '/pt-br/about/legal/privacy/',
    privacyText: "A Citrix só irá processar seus dados de acordo com a nossa",
    privacyText2: "",
    resetText: "Se o formulário estiver pré-preenchido, mas os dados não são os seus, por favor,",
    resetText2: "para reiniciá-lo.",
    resetLinkText: "clique aqui",
    yes: "Sim",
    no: "Não",
    submitBtn: {
        "Submit" : "Enviar",
        "Get the eBook" : "Obtenha o e-Book",
        "Watch demo" : "Assista à demonstração",
        "Get the kit" : "Obtenha o kit",
        "Compare now" : "Compare agora",
        "Request a demo": "Solicite uma demonstração",
        "Request a call": "Solicite uma ligação"
    },
    apjPrivacy:{
        title: "Como usamos suas informações pessoais",
        company: "Citrix Systems Japan K.K.",
        part1: "(\"Citrix\") usará e armazenará suas informações pessoais de acordo com as leis e regulamentos de proteção de dados aplicáveis ​​e a",
        linkText: "Citrixpolítica de privacidade,",
        part2: "e em circunstâncias em que o acesso seja rigorosamente restrito. A Citrix usará suas informações pessoais somente de acordo com o que estiver estipulado na política de privacidade e não para outros fins. De acordo com a política de privacidade da Citrix, podemos confiar o processamento de informações pessoais a entidades comerciais nacionais ou estrangeiras, compartilhar informações pessoais com outros escritórios ou subsidiárias da Citrix em todo o mundo ou enviar informações pessoais a terceiros nacionais ou internacionais. Quando você envia suas informações pessoais para a Citrix, concorda com a coleta e processamento de suas informações pessoais conforme descrito na política de privacidade da Citrix.",
        privacyAccept: "Li e aceito a política de privacidade da Citrix"
    },
    fields: {
        "AnnualSales": {
            label: "Annual Sales"
        },
        "Company_Self_Reported__c": {
            label: "Empresa"
        },
        "department": {
            label: "Departamento",
            options: [
                { value: "Application Management", text: "Gerenciamento de aplicativos" },
                { value: "Consulting Services", text: "Serviços de Consultoria" },
                { value: "Education / Training", text: "Educação/treinamento" },
                { value: "Engineering", text: "Engenharia" },
                { value: "Executive Office / Administration", text: "Escritório executivo/administração" },
                { value: "Finance / Accounting", text: "Finanças/contabilidade" },
                { value: "Human Resources", text: "Recursos humanos" },
                { value: "Information Technology - Systems", text: "Sistemas de tecnologia da informação" },
                { value: "Legal", text: "Jurídico" },
                { value: "Marketing / PR", text: "Marketing/RP" },
                { value: "Networking", text: "Redes" },
                { value: "Operations / Manufacturing", text: "Operações/Fabricação" },
                { value: "Pre-Sales / Technical Support", text: "Pré-vendas/Suporte técnico" },
                { value: "Project Management", text: "Gerenciamento de projeto" },
                { value: "Purchasing", text: "Compras" },
                { value: "Sales / Bus-Corp Development", text: "Vendas/Desenvolvimento emp-corp" },
                { value: "Security", text: "Segurança" },
                { value: "Web / Online / E-Business", text: "Web/On-line/e-business" }
            ]
        },
        "Industry_Self_Reported__c": {
            label: "Indústria",
            options: [
                { value: "Agriculture", text: "Agricultura" },
                { value: "Art & Membership", text: "Arte e associação" },
                { value: "Conglomerate", text: "Conglomerado" },
                { value: "Construction and Design", text: "Construção e design" },
                { value: "Business Consulting", text: "Consultoria comercial" },
                { value: "E-Commerce", text: "E-commerce" },
                { value: "Education", text: "Educação" },
                { value: "Engineering", text: "Engenharia" },
                { value: "Entertainment", text: "Entretenimento" },
                { value: "Chemical Manufacturing", text: "Fabricação de produtos químicos" },
                { value: "Pharmaceuticals", text: "Farmacêutica" },
                { value: "Charitable/Non-Profit", text: "Filantropia/sem fins lucrativos" },
                { value: "Finance", text: "Finanças" },
                { value: "Government/State-Province", text: "Governo/estadual" },
                { value: "Government/Local", text: "Governo/local" },
                { value: "Government/National-Federal", text: "Governo/nacional-federal" },
                { value: "Hospitality", text: "Hotelaria" },
                { value: "Real Estate", text: "Imobiliário" },
                { value: "Legal", text: "Jurídico" },
                { value: "Manufacturing", text: "Manufatura" },
                { value: "Mining - All", text: "Mineração - todas" },
                { value: "Oil and Gas", text: "Petróleo e gás" },
                { value: "Consumer Packaged Goods", text: "Produtos embalados de consumo" },
                { value: "Publishing/Printing", text: "Publicação/impressão" },
                { value: "Health Care", text: "Saúde" },
                { value: "Insurance", text: "Seguro" },
                { value: "Service Provider", text: "Service Provider" },
                { value: "Business/Personal Services", text: "Serviços comerciais/pessoais" },
                { value: "Personnel Services", text: "Serviços de pessoal" },
                { value: "Household Services", text: "Serviços domésticos" },
                { value: "Professional Services", text: "Serviços profissionais" },
                { value: "Utilities", text: "Serviços públicos" },
                { value: "Technology", text: "Tecnologia" },
                { value: "Telecommunication", text: "Telecomunicações" },
                { value: "Transportation", text: "Transporte" },
                { value: "Retail/Wholesale", text: "Varejo/atacado" }
            ]
        },
        "NumberOfEmployees_Self_Reported__c" : {
            label: "Porte da empresa",
            options: [
                { value: "50", text: "1-50" },
                { value: "500", text: "51-500" },
                { value: "749", text: "501-749" },
                { value: "4999", text: "750-4,999" },
                { value: "19999", text: "5,000-19,999" },
                { value: "20000", text: "20,000+" }
            ]
        },
        "NumberofEmployees__here___atlocation": {
            label: "Porte da empresa",
            options: [
                { value: "5,001 +", text: "5.001 +" },
                { value: "1,001 to 5,000", text: "1.001 a 5.000" },
                { value: "501 to 1,000", text: "501 a 1.000" },
                { value: "251 to 500", text: "251 a 500" },
                { value: "1 to 250", text: "1 a 250" }
            ]
        },
        "Address2": {
            label: "Linha do endereço 2"
        },
        "Address3": {
            label: "Linha do endereço 3"
        },
        "city": {
            label: "Cidade"
        },
        "country": {
            label: "País"
        },
        "email": {
            label: "E-mail comercial"
        },
        "firstName": {
            label: "Nome"
        },
        "lastName": {
            label: "Sobrenome"
        },
        "phone": {
            label: "Telefone"
        },
        "mobilePhone": {
            label: "Mobile Phone"
        },
        "postalCode": {
            label: "CEP/Código postal"
        },
        "salutation": {
            label: "Saudação",
            options: [
                { value: "", text: ""},
                { value: "Dr.", text: "Dr."},
                { value: "Egr. Sig.", text: "Egr. Sig."},
                { value: "Frau", text: "Frau"},
                { value: "Gent.ma Sig.ra", text: "Gent.ma Sig.ra"},
                { value: "Herr", text: "Herr"},
                { value: "Madame", text: "Madame"},
                { value: "Mademoiselle", text: "Mademoiselle"},
                { value: "Miss", text: "Miss"},
                { value: "Monsieur", text: "Monsieur"},
                { value: "Mr.", text: "Mr."},
                { value: "Mrs.", text: "Mrs."},
                { value: "Ms.", text: "Ms."},
                { value: "Professor", text: "Professor"},
                { value: "Señor", text: "Señor"},
                { value: "Señora", text: "Señora"}
            ]
        },
        "state": {
            label: "Estado/província"
        },
        "address": {
            label: "Endereço"
        },
        "Job_Title__c": {
            label: "Cargo",
            options: [
                { value: "System Administrator", text: "Administrador de sistemas" },
                { value: "Network Administrator / Engineer", text: "Administrador/engenheiro de redes" },
                { value: "Analyst", text: "Analista" },
                { value: "Architect", text: "Arquiteto" },
                { value: "Assistant", text: "Assistente" },
                { value: "Business Manager", text: "Business Manager" },
                { value: "Consultant", text: "Consultor" },
                { value: "Developer / Programmer", text: "Desenvolvedor/programador" },
                { value: "Director", text: "Diretor" },
                { value: "Student", text: "Estudante" },
                { value: "IT Manager", text: "Gerente de TI" },
                { value: "C-Level / President / VP", text: "Nível C/presidente/VP" },
                { value: "Owner / Partner", text: "Proprietário/Parceiro" }
            ]
        },
        "Project_Budget__c": {
            label: "Orçamento de projeto",
            options: [
                { value: "Yes", text: "Sim" },
                { value: "No", text: "Não" },
                { value: "Unknown", text: "Desconhecido" }
            ]
        },
        "Primary_Product_Interest__c": {
            label: "CTRL para selecionar mais de uma opção (máximo de 5 opções)"
        },
        "Purchase_Timeframe__c": {
            label: "Prazo para a compra",
            options: [
                { value: "3 months or less", text: "3 meses ou menos" },
                { value: "4 to 6 months", text: "4 a 6 meses" },
                { value: "7 months or more", text: "7 meses ou mais" },
                { value: "No time frame", text: "Nenhum horizonte de tempo" },
                { value: "Unknown", text: "Não tenho certeza" }
            ]
        },
        "Email_Blast_OK__c": {
            label: "Podemos enviar e-mails para você?",
            options: [
                { value: "Yes", text: "Sim" },
                { value: "No", text: "Não" }
            ]
        },
        "Direct_Mail_OK__c": {
            label: "May we contact you by mail?",
            options: [
                { value: "Yes", text: "Sim" },
                { value: "No", text: "Não" }
            ]
        },
        "OK_to_Call__c": {
            label: "Podemos ligar para você?",
            options: [
                { value: "Yes", text: "Sim" },
                { value: "No", text: "Não" }
            ]
        },
        "Preferred_Language__c": {
            label: "Preffered language"
        },
        "Sales_Contact_Requested__c": {
            label: "Quero ser contatado por uma pessoa de Vendas"
        },
        "Comments_6__c":{
            label: "Comentários"
        },
        //PrefCenter fields/options
        "Unsubscribed": {
            label: "Cancelar o recebimento de todas as comunicações de marketing por e-mail.",
            options: [...yesNoOptions]
        },
        "Marketing_Suspended_30_Days__c": {
            label: "Suspender as comunicações por 30 dias.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Workspace__c": {
            label: "Como espaços de trabalho digitais completos, que incluem aplicativos, desktops, arquivos e dispositivos móveis, ajudam você a ter o melhor desempenho onde quer que esteja.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_VirtualAppsDesktops__c": {
            label: "Como acessar de forma segura todos os aplicativos, desktops e dados, em qualquer dispositivo.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_NetworkingADC__c": {
            label: "Como gerenciar a entrega de aplicativos monolíticos e baseados em microsserviços em um mundo híbrido e multinuvem.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_SDWan__c": {
            label: "Como fornecer a rede de alto desempenho e em funcionamento constante de que seus funcionários precisam.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Analytics__c": {
            label: "Como detectar ameaças à segurança e anomalias de desempenho com análises e insights, e impedi-las antes que aconteçam.",
            options: [...yesNoOptions]
        }
    },
    optOut: {
        formTitle: "Cancelar a assinatura",
        thankyou: "As suas preferências de e-mail foram atualizadas. Se isso tiver sido feito por engano ou se você quiser revisar suas preferências, visite o nosso Centro de Preferências a qualquer momento.",
        formDescription: "É uma pena ver você partir. Venha nos visitar em Citrix.com em algum momento. Estamos sempre adicionando novos recursos e funções para garantir que os produtos Citrix funcionem para você.",

    },
    preferenceCenter: {
        formTitle: "Centro de Preferências de e-mails da Citrix",
        thankyou: "<h3>Alterações em assinatura confirmadas!</h3><p>As suas preferências de e-mail foram atualizadas.</p>",
        formDescription: "Suas preferências de e-mail e comunicações são importantes para nós. Nosso objetivo é fornecer informações que ajudem você e sua organização a reforçar uma forma melhor de trabalhar.  Atualize suas preferências de e-mail para que possamos garantir que você receba comunicações da Citrix que lhe sejam importantes.",
        labelOne: "Conte-nos mais sobre você.",
        labelTwo: "Quais são os seus interesses?",
        labelThree: "Como você prefere receber comunicações?",
    },
    validation: validationMessages
}